import { ErrorMessage, MessageAlignment } from '../../common/error-message/ErrorMessage';

/**
 * The component that is displayed during the authentication flow.
 */
export const ErrorMessageAuthenticaton = (): JSX.Element | null => {
  return <ErrorMessage keyMessage="AuthenticationError" alignMessage={MessageAlignment.Middle}></ErrorMessage>;
};
